jQuery(document).foundation();

jQuery(document).ready(function($) {

  var mainContentSticky = '';
  var idToStick = '';
  var mainHeight = '';
  var sidebarHeight = '';

  function setSmartSticky() {
    if ( typeof(mainContentSticky) == 'object' ) {
      mainContentSticky.destroy();
    }
    if ( Foundation.MediaQuery.is('medium down') ) {
      return false;
    }
    mainHeight = $('#main .smart-sticky-inner').outerHeight();
    sidebarHeight = $('#side .smart-sticky-inner').outerHeight();
    topSpacing = 0;

    idToStick = ( mainHeight < sidebarHeight ? '#main' : '#side');

    mainContentSticky = new StickySidebar(idToStick, {
      containerSelector: '#body-wrapper',
      innerWrapperSelector: '.smart-sticky-inner',
      topSpacing: topSpacing,
      bottomSpacing: 0
    });
  }

  setSmartSticky();

  $(window).on('changed.zf.mediaquery', function(event, newSize, oldSize) {
    setSmartSticky();
  });

  $(window).on('down.zf.accordion', function() {
    setTimeout(() => { setSmartSticky(); }, 2000);
  });

  function filterNews() {
    var selected = '';
    var data = new Object();
    data.taxonomy = [];
    data.taxonomyOperator = [];
    data.taxonomyTerms = [];
    $('.news-filter').each(function(i, obj) {
        if ( obj.value == '0' ) {
          return true;
        }
        var selected = $(obj).find(':selected').data();
        data.taxonomy.push(selected.taxonomy);
        data.taxonomyOperator.push(selected.taxonomyOperator);
        data.taxonomyTerms.push(selected.taxonomyTerms);
    });

    var filterData = new Object();
    filterData.taxonomy = data.taxonomy.join(':');
    filterData.taxonomyOperator = data.taxonomyOperator.join(':');
    filterData.taxonomyTerms = data.taxonomyTerms.join(':');
    filterData.preloaded = false;
    var transition = 'fade';
    var speed = '300'; console.log(filterData);
    ajaxloadmore.filter(transition, speed, filterData);
  }

  $('.news-filter').on('change', function() {
    filterNews();
  });

  $('.news-filter-clear').on('click', function() {
    $('.news-filter').val('0');
    filterNews();
  });

  window.almComplete = function(alm){
    // Adjust smart sticky for new content
    setTimeout(() => { setSmartSticky(); }, 1000);
  }

  $('.cngvp-carousel').slick({
      autoplay: true,
      cssEase: 'ease-out',
      autoplaySpeed: 5000,
      prevArrow: '<span class="slick-prev"><i class="fa-regular fa-chevron-left"></i></span>',
      nextArrow: '<span class="slick-next"><i class="fa-regular fa-chevron-right"></i></span>'
    });

  $('.menu-toggle').on('click', function() {
    $('.site-nav').toggleClass('open');
  });

  $('.newsletter-toggle').on('click', function() {
    $('.newsletter-signup').toggleClass('open');
  });

});